import {
    MedicalHistory
} from 'one-state-medicalhistory/src/medicalhistory';
/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * Medical History Component
 * @param response has the backend
 * Medical History component response
 * @param context has settings etc..
 */

export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */
    let result :any = {
        medicalhistory:[],
        error:undefined
    }

    const { log } = context;
    if (response && (response.status >= 400 || response.type == "error")) {
        result.error=response;
     }
    if (response && response.length > 0) {
        const rs = response;
        let medicalhistories:MedicalHistory[] =[]
        rs.map((ele: any) => {
            let historyobj: MedicalHistory = {
                id: "",
                diagnosisName: ""
            }
            historyobj.diagnosisName = ele.DiagnosisName;
            // result.push(historyobj);
            medicalhistories.push(historyobj);
        });
        result.medicalhistory=medicalhistories;
    }
    log.debug(
        "ccw-gadget,medicalhistory-epic",
        "medicalhistory-epic transformation response ", {
        result
    });
    return result;
}